module.exports = __webpack_public_path__ + "static/media/parceiro-txfiber.90f6a4f1.webp";